export const fetchWalletPass = async (offerID: string, platform: string): Promise<Response> => {
  return fetch(`${process.env.EDGE_URL}/${process.env.V_PREFIX}/walletpass/${offerID}?a=b&api_key=${process.env.API_KEY}&platform=${platform}`, {
    headers: {
      Authorization: `Basic ${process.env.ICO_TOKEN}`,
      Date: new Date().toUTCString(),
    },
    method: 'GET',
    mode: 'cors',
    redirect: 'follow',
  }).then((res) => res);
};
